<template>
  <el-table-column align="center" label="下架歌单信息">
    <el-table-column label="歌单ID" width="120" prop="tracklistId"></el-table-column>
    <el-table-column label="歌单信息" width="310" v-slot="{ row }">
      <track-info-mod :data="row"></track-info-mod>
    </el-table-column>
    <template v-if="showExtra">
      <el-table-column label="歌曲编码" prop="trackNumber"></el-table-column>
      <el-table-column label="ISRC" prop="isrc"></el-table-column>
      <el-table-column label="专辑编码" prop="discNumber"></el-table-column>
      <el-table-column label="UPC" prop="upc"></el-table-column>
      <el-table-column label="专辑发行时间" width="120" prop="saleTime"></el-table-column>
      <el-table-column label="歌曲视频别名" width="120" prop="originTrackName"></el-table-column>
      <el-table-column label="曲序" prop="location"></el-table-column>
      <el-table-column label="专辑别名" prop="originAlbumName"></el-table-column>
    </template>
  </el-table-column>
</template>

<script>
import TrackInfoMod from './TrackInfoMod.vue'

export default {
  name: 'OfflineInfoCol',
  components: {
    TrackInfoMod
  },
  props: {
    showExtra: Boolean,
  },
}
</script>
